import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Pages
import LandingPage from './pages/LandingPage';
import OrderPage49 from './pages/OrderPage49';
import UpsellPage from './pages/UpsellPage';
import IntakeFormPage from './pages/IntakeFormPage';
import PaymentPage from './pages/PaymentPage';
import StatusPage from './pages/StatusPage';
import ClientDossierView from './pages/ClientDossierView';
import SEOInfoPage from './pages/SEOInfoPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AffiliateRegisterPage from './pages/AffiliateRegisterPage';
import AffiliateRedirect from './pages/AffiliateRedirect';
import AdminAffiliates from './pages/AdminAffiliates';
import AdminClients from './pages/AdminClients';
import AffiliateLogin from './pages/AffiliateLogin';
import AffiliateDashboard from './pages/AffiliateDashboard';
import ThankYouPage from './pages/ThankYouPage';
import ClientLogin from './pages/ClientLogin';
import ClientDashboard from './pages/ClientDashboard';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/order" element={<OrderPage49 />} />
          <Route path="/upsell" element={<UpsellPage />} />
          <Route path="/intake" element={<IntakeFormPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/dossier" element={<ClientDossierView />} />
          <Route path="/info" element={<SEOInfoPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/affiliates" element={<AdminAffiliates />} />
          <Route path="/admin/clients" element={<AdminClients />} />
          <Route path="/devenir-partenaire" element={<AffiliateRegisterPage />} />
          <Route path="/connexion-partenaire" element={<AffiliateLogin />} />
          <Route path="/espace-partenaire" element={<AffiliateDashboard />} />
          <Route path="/merci" element={<ThankYouPage />} />
          <Route path="/espace-client/connexion" element={<ClientLogin />} />
          <Route path="/espace-client" element={<ClientDashboard />} />
          <Route path="/r/:slug" element={<AffiliateRedirect />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
